import { AxiosError, AxiosResponse } from 'axios';

import Config from '../../shared/config';
import { DomainOptionModel } from '../../dashboard/models/DomainOptionsModel';
import useSWR from 'swr';

/** Load options for the domain. */
export function useDomainOptions() {
  const { data: domainOptionsResponse } = useSWR<
    AxiosResponse<DomainOptionModel>,
    AxiosError<Error>
  >(`${Config.API}/api/domain/list/option`);
  return {
    siteEmailOptions: domainOptionsResponse?.data?.assets?.emailOptions,
    expirywarning: domainOptionsResponse?.data?.assets?.expirywarning || 30
  };
}
